import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const Snapchat = React.lazy(() => import('./Snapchat'));

export default class SnapchatWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <Snapchat
            config={this.props.config}
            reportEvent={this.props.reportEvent(this.props.config.snapchat_pixel_id)}
          />
        </Suspense>
      </div>
    );
  }
}

SnapchatWrapper.propTypes = {
  config: PropTypes.object,
  reportEvent: PropTypes.func,
};
